/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import container from 'modules/section-content';
import splash from './pages/dpa-page.pug';
import metadata from './metadata.json';
import dpaPapers from './data/dpaPapers.json';

export default function register() {
  page('/legal/baseline/dpa', render);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    dpaPapers,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}



// WEBPACK FOOTER //
// ./src/pages/legals/dpa/dpa.js